import React from 'react';
import AboutPreview from'../components/About/AboutPreview';
import useAPI from '../hooks/useAPI';
import About from '../components/About/About';

const AboutPage = () => {
  const {
    data: teamData,
    loading,
    error,
  } = useAPI('/team');

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // const team = teamData?.data || teamData; // adjust based on API structure
  console.log("API URL:", teamData);
  return (
    <div className="pt-20">
      <About />
      <AboutPreview teamData={teamData} />
    </div>
  );
};

export default AboutPage;